var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.5,
    height: 16.5,
    rx: 8.25,
    fill: "white",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9C30 12.3137 27.3137 15 24 15C20.6863 15 18 12.3137 18 9C18 5.68629 20.6863 3 24 3C27.3137 3 30 5.68629 30 9Z",
    fill: "#5D903D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTrue);
export default __webpack_public_path__ + "static/media/switch_true.e7cbc389cff5de166cf10f80b7857b75.svg";
export { ForwardRef as ReactComponent };